const priceFormatterEmptyIfNull = (price = null, currency = "zł") => {
  if (price === null) return null;
  const priceValue = parseFloat(`${+price}` || "0").toFixed(2);
  return `${priceValue}${currency}`;
};
export default priceFormatterEmptyIfNull;
